import { render, staticRenderFns } from "./TabCost.vue?vue&type=template&id=252c3630"
import script from "./TabCost.vue?vue&type=script&lang=ts"
export * from "./TabCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports